import { User } from "../Model/User";
import { AuthRepository } from "../Repository/AuthRepository";

export interface CreateAuthUseCase {
  login: (email: string, password: string) => Promise<User>;
}

export class LoginUseCase implements CreateAuthUseCase {
  private authRepo: AuthRepository;
  constructor(_AuthRepo: AuthRepository) {
    this.authRepo = _AuthRepo;
  }

  async login(email: string, password: string){
     
    const login = this.authRepo.login(email, password);
    return login;
  }
}